module.exports = __webpack_public_path__ + "img/ourWork1.1b797f1c.jpg";